import { createReducer } from '@reduxjs/toolkit';
import { authActions } from '../auth';
import { projectsActions } from '../projects';
import { sprintsActions } from '../sprints';
import { tasksActions } from '../tasks';

const {
  registerRequest,
  registerSuccess,
  registerError,
  loginRequest,
  loginSuccess,
  loginError,
  logoutRequest,
  logoutSuccess,
  logoutError,
  getCurrUserRequest,
  getCurrUserSuccess,
  getCurrUserError,
} = authActions;

const {
  getProjectsRequest,
  getProjectsSuccess,
  getProjectsError,
  addProjectRequest,
  addProjectSuccess,
  addProjectError,
  deleteProjectRequest,
  deleteProjectSuccess,
  deleteProjectError,
  editProjectRequest,
  editProjectSuccess,
  editProjectError,
  addTeammateRequest,
  addTeammateSuccess,
  addTeammateError,
} = projectsActions;

const {
  getSprintsRequest,
  getSprintsSuccess,
  getSprintsError,
  addSprintRequest,
  addSprintSuccess,
  addSprintError,
  deleteSprintRequest,
  deleteSprintSuccess,
  deleteSprintError,
  editSprintRequest,
  editSprintSuccess,
  editSprintError,
} = sprintsActions;

const {
  getTasksRequest,
  getTasksSuccess,
  getTasksError,
  addTaskRequest,
  addTaskSuccess,
  addTaskError,
  deleteTaskRequest,
  deleteTaskSuccess,
  deleteTaskError,
  editTaskRequest,
  editTaskSuccess,
  editTaskError,
  addTaskHoursRequest,
  addTaskHoursSuccess,
  addTaskHoursError,
  editScheduledHoursRequest,
  editScheduledHoursSuccess,
  editScheduledHoursError,
} = tasksActions;

const loading = createReducer(false, {
  [registerRequest]: () => true,
  [registerSuccess]: () => false,
  [registerError]: () => false,
  [loginRequest]: () => true,
  [loginSuccess]: () => false,
  [loginError]: () => false,
  [logoutRequest]: () => true,
  [logoutSuccess]: () => false,
  [logoutError]: () => false,
  [getCurrUserRequest]: () => true,
  [getCurrUserSuccess]: () => false,
  [getCurrUserError]: () => false,
  [getProjectsRequest]: () => true,
  [getProjectsSuccess]: () => false,
  [getProjectsError]: () => false,
  [addProjectRequest]: () => true,
  [addProjectSuccess]: () => false,
  [addProjectError]: () => false,
  [deleteProjectRequest]: () => true,
  [deleteProjectSuccess]: () => false,
  [deleteProjectError]: () => false,
  [editProjectRequest]: () => true,
  [editProjectSuccess]: () => false,
  [editProjectError]: () => false,
  [addTeammateRequest]: () => true,
  [addTeammateSuccess]: () => false,
  [addTeammateError]: () => false,
  [getSprintsRequest]: () => true,
  [getSprintsSuccess]: () => false,
  [getSprintsError]: () => false,
  [addSprintRequest]: () => true,
  [addSprintSuccess]: () => false,
  [addSprintError]: () => false,
  [deleteSprintRequest]: () => true,
  [deleteSprintSuccess]: () => false,
  [deleteSprintError]: () => false,
  [editSprintRequest]: () => true,
  [editSprintSuccess]: () => false,
  [editSprintError]: () => false,
  [getTasksRequest]: () => true,
  [getTasksSuccess]: () => false,
  [getTasksError]: () => false,
  [addTaskRequest]: () => true,
  [addTaskSuccess]: () => false,
  [addTaskError]: () => false,
  [deleteTaskRequest]: () => true,
  [deleteTaskSuccess]: () => false,
  [deleteTaskError]: () => false,
  [editTaskRequest]: () => true,
  [editTaskSuccess]: () => false,
  [editTaskError]: () => false,
  [addTaskHoursSuccess]: () => true,
  [addTaskHoursRequest]: () => false,
  [addTaskHoursError]: () => false,
  [editScheduledHoursRequest]: () => true,
  [editScheduledHoursSuccess]: () => false,
  [editScheduledHoursError]: () => false,
});

export default loading;
